import React from 'react';
import dayjs, { Dayjs } from 'dayjs';

import { DATE_TIME_FORMAT } from 'common-utils/date-utils';
import { BasicForm, CustomFormItem, DateTimePickerFormItem, KeyValueDisplay, Typography } from 'ui-lib';

import deploymentCss from '../../../deployments.css';
import css from '../../deployment-create.css';

import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
interface IScheduleStepProps {
    selectedScheduleDate?: Date;
    deviceGroups: string[];
    onChange: (date: Date) => void;
}

export const ScheduleStep = (props: IScheduleStepProps): JSX.Element => {
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    return (
        <div className={deploymentCss.targetSettings}>
            <section className={deploymentCss.settings}>
                <BasicForm
                    cardPros={{ bordered: false }}
                    items={[
                        <CustomFormItem label='Device groups' code='deviceGroups' colon={true} labelAlign='right'>
                            {props.deviceGroups.length ? (
                                <ul className={css.reviewList}>
                                    {props.deviceGroups.map((deviceGroup) => (
                                        <li key={deviceGroup}>{deviceGroup}</li>
                                    ))}
                                </ul>
                            ) : (
                                '-'
                            )}
                        </CustomFormItem>,
                        <DateTimePickerFormItem
                            code='raptorScheduledDateField'
                            label='Scheduled date'
                            labelAlign='right'
                            colon={true}
                            disabledDateType='DISABLE_PAST_DATES'
                            showTime={true}
                            minuteStep={5}
                            showNow={false}
                            allowClear={false}
                            initialValue={props.selectedScheduleDate ? dayjs(props.selectedScheduleDate) : null}
                            dateFormat={DATE_TIME_FORMAT.DATE_AND_SHORT_TIME}
                            onChange={(value: Dayjs): void => {
                                if (!value) return;
                                const date = value.toDate();
                                date.setSeconds(0);
                                props.onChange(date);
                            }}
                        />,
                    ]}
                />
            </section>
            <section className={deploymentCss.description}>
                <KeyValueDisplay
                    column={1}
                    items={[
                        {
                            title: 'Note',
                            content: (
                                <Typography.Text type='warning'>
                                    The scheduled date and time are interpreted using your browser&apos;s local
                                    timezone.
                                </Typography.Text>
                            ),
                        },
                        {
                            title: 'Timezone',
                            content: <Typography.Text code>{localTimezone}</Typography.Text>,
                        },
                        {
                            title: 'Out of service settings',
                            content: 'Not supported for RAPTOR deployments.',
                        },
                    ]}
                />
            </section>
        </div>
    );
};
